import React from 'react';
import { Link } from '@this/shared/ui/navigations/link';
import { isMynavi, isTabikobo, isAiTravel } from '@this/src/util';

interface TermsAndConditionsProps {
  serviceId: number;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ serviceId }) => {
  if (isMynavi(serviceId)) {
    return (
      <>
        予約依頼時に、
        <Link
          href="https://btm.mynavi.jp/terms/pdf/hojinkiyaku.pdf"
          target="_blank"
          rel="noopener"
          isExternal
          size="small"
        >
          マイナビBTM会員向け利用規約
        </Link>
        、
        <Link
          href="https://btm.mynavi.jp/terms/pdf/yakkan_arrange.pdf"
          target="_blank"
          rel="noopener"
          isExternal
          size="small"
        >
          標準旅行業約款
        </Link>
        、
        <Link
          href="https://btm.mynavi.jp/terms/pdf/privacypolicy.pdf"
          target="_blank"
          rel="noopener"
          isExternal
          size="small"
        >
          個人情報の取り扱い
        </Link>
        について同意するものとします。
      </>
    );
  }

  if (isTabikobo(serviceId)) {
    return (
      <>
        予約（決済）時に弊社の
        <Link href="https://www.tabikobo.com/policy/" target="_blank" rel="noopener" isExternal size="small">
          個人情報保護方針
        </Link>
        に同意するものとします。
      </>
    );
  }

  if (isAiTravel(serviceId)) {
    return (
      <>
        ユーザーは、キャンセル時に株主優待券を受領した場合、弊社に返却の必要があることをご了承ください。
        <br />
        <br />
        予約（決済）時に弊社の
        <Link href="https://aitravel.cloud/tos/" target="_blank" rel="noopener" isExternal size="small">
          利用約款
        </Link>
        、
        <Link
          href="https://d14vxaqxdw6ji3.cloudfront.net/images/travel_terms.pdf"
          target="_blank"
          rel="noopener"
          isExternal
          size="small"
        >
          旅行業約款
        </Link>
        ・
        <Link
          href="https://d14vxaqxdw6ji3.cloudfront.net/images/requirements.pdf"
          target="_blank"
          rel="noopener"
          isExternal
          size="small"
        >
          手配旅行条件書
        </Link>
        、
        <Link
          href="https://transferdata.co.jp/privacy-policy#a"
          target="_blank"
          rel="noopener"
          isExternal
          size="small"
        >
          プライバシーポリシー
        </Link>
        に同意するものとします。
      </>
    );
  }

  return null;
};

export default TermsAndConditions;
